<template>
  <el-dialog
      title="修改跟进状态"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="20%">
    <el-form>
      <el-form-item label="跟进状态：">
        <el-select v-model="followState" placeholder="请选择跟进状态">
          <el-option
              v-for="item in followStateOptions"
              :key="item.id"
              :label="item.description"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmChange">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { DictionaryApis } from "@/apis";
import { DictionaryKey } from "@/utils/enum";

export default {
  data() {
    return {
      dialogVisible: false,
      followStateOptions: '',
      followState: '',
      listId: '',
    }
  },
  methods: {
    open(listId) {
      this.listId = listId;
      this.followState = '';
      this.getFollowState();
    },
    async getFollowState() {
      this.followStateOptions = await  DictionaryApis.getDictValueByKey(DictionaryKey.FollowState);
      this.followState = this.followStateOptions[0].id;
      this.dialogVisible = true;
    },
    confirmChange() {
      this.$axios.post(`Crm/Customer/ModifyCustomerData`,{
        listId: this.listId,
        followupStateId: this.followState
      }).then(() => {
        this.$message.success(`修改成功！`);
        this.$emit(`complete`);
        this.dialogVisible = false;
      })
    }
  }
}
</script>

<style scoped>

</style>